// AUTO-GENERATED by scripts/generate-page-sdk-types.mjs - do not edit by hand.
// The named exports of @diagonal-hq/pages: each export name and its member path
// on the Page SDK. The page host, the package, the build, and the codemod read it.

export const PAGES_SDK_PACKAGE = "@diagonal-hq/pages";

export const PAGE_SDK_EXPORTS: Readonly<Record<string, readonly string[]>> = Object.freeze({
  Accordion: ["Components","Accordion"],
  AdminNavButtons: ["Components","AdminNavButtons"],
  AiAgentButton: ["Components","AiAgentButton"],
  Alert: ["Components","Alert"],
  AnalyticsEmbed: ["Components","AnalyticsEmbed"],
  Avatar: ["Components","Avatar"],
  Badge: ["Components","Badge"],
  BarChart: ["Components","BarChart"],
  Breadcrumb: ["Components","Breadcrumb"],
  Button: ["Components","Button"],
  ButtonLink: ["Components","ButtonLink"],
  Calendar: ["Components","Calendar"],
  CalendarConnections: ["Components","CalendarConnections"],
  CalendarNextButton: ["Components","CalendarNextButton"],
  CalendarPrevButton: ["Components","CalendarPrevButton"],
  CalendarSelector: ["Components","CalendarSelector"],
  CalendarTitle: ["Components","CalendarTitle"],
  CalendarTodayButton: ["Components","CalendarTodayButton"],
  CalendarViewSwitcher: ["Components","CalendarViewSwitcher"],
  Card: ["Components","Card"],
  Collapsible: ["Components","Collapsible"],
  ConfirmDialog: ["Components","ConfirmDialog"],
  CreateResourceRecordForm: ["Components","CreateResourceRecordForm"],
  DataTable: ["Components","DataTable"],
  DataTableAddFilter: ["Components","DataTableAddFilter"],
  DataTableBulkActions: ["Components","DataTableBulkActions"],
  DataTableColumnToggle: ["Components","DataTableColumnToggle"],
  DataTableContent: ["Components","DataTableContent"],
  DataTableFilterChips: ["Components","DataTableFilterChips"],
  DataTableFilters: ["Components","DataTableFilters"],
  DataTablePagination: ["Components","DataTablePagination"],
  DataTableRowActions: ["Components","DataTableRowActions"],
  DataTableSearch: ["Components","DataTableSearch"],
  DataTableToolbar: ["Components","DataTableToolbar"],
  DeleteResourceRecord: ["Components","DeleteResourceRecord"],
  Dnd: ["Dnd"],
  DropdownMenu: ["Components","DropdownMenu"],
  EmailComposer: ["Components","EmailComposer"],
  EmailMessages: ["Components","EmailMessages"],
  EmptyState: ["Components","EmptyState"],
  ErrorBoundary: ["Components","ErrorBoundary"],
  ForgotPasswordForm: ["Components","ForgotPasswordForm"],
  FormCheckbox: ["Components","FormCheckbox"],
  FormCheckboxGroupInput: ["Components","FormCheckboxGroupInput"],
  FormCodeInput: ["Components","FormCodeInput"],
  FormColorInput: ["Components","FormColorInput"],
  FormComboboxInput: ["Components","FormComboboxInput"],
  FormContentInput: ["Components","FormContentInput"],
  FormDateInput: ["Components","FormDateInput"],
  FormDatetimeInput: ["Components","FormDatetimeInput"],
  FormFieldDisplay: ["Components","FormFieldDisplay"],
  FormFieldInput: ["Components","FormFieldInput"],
  FormFileUpload: ["Components","FormFileUpload"],
  FormLocationInput: ["Components","FormLocationInput"],
  FormMarkdownInput: ["Components","FormMarkdownInput"],
  FormMoneyInput: ["Components","FormMoneyInput"],
  FormMultiComboboxInput: ["Components","FormMultiComboboxInput"],
  FormNumberInput: ["Components","FormNumberInput"],
  FormPasswordInput: ["Components","FormPasswordInput"],
  FormPhoneInput: ["Components","FormPhoneInput"],
  FormRadio: ["Components","FormRadio"],
  FormSelectInput: ["Components","FormSelectInput"],
  FormSlider: ["Components","FormSlider"],
  FormSwitch: ["Components","FormSwitch"],
  FormTextArea: ["Components","FormTextArea"],
  FormTextInput: ["Components","FormTextInput"],
  FormTimeInput: ["Components","FormTimeInput"],
  FormTimezoneInput: ["Components","FormTimezoneInput"],
  HasAnyPermission: ["Components","HasAnyPermission"],
  HasPermission: ["Components","HasPermission"],
  Icon: ["Components","Icon"],
  Iframe: ["Components","Iframe"],
  Image: ["Components","Image"],
  KeyValueList: ["Components","KeyValueList"],
  LineChart: ["Components","LineChart"],
  Link: ["Components","Link"],
  List: ["Components","List"],
  LoginForm: ["Components","LoginForm"],
  LogoutButton: ["Components","LogoutButton"],
  Map: ["Components","Map"],
  Modal: ["Components","Modal"],
  NavMain: ["Components","NavMain"],
  NotificationComposer: ["Components","NotificationComposer"],
  NotificationConsentForm: ["Components","NotificationConsentForm"],
  NotificationHistory: ["Components","NotificationHistory"],
  NotificationVariablesForm: ["Components","NotificationVariablesForm"],
  PackageReleaseNotes: ["Components","PackageReleaseNotes"],
  PageHeader: ["Components","PageHeader"],
  Pages: ["Pages"],
  PaymentForm: ["Components","PaymentForm"],
  PaymentMethods: ["Components","PaymentMethods"],
  PieChart: ["Components","PieChart"],
  Popover: ["Components","Popover"],
  QrCode: ["Components","QrCode"],
  RecordFields: ["Components","RecordFields"],
  RecordScheduleDisplay: ["Components","RecordScheduleDisplay"],
  ResourceTable: ["Components","ResourceTable"],
  RestoreResourceRecord: ["Components","RestoreResourceRecord"],
  RichText: ["Components","RichText"],
  ScheduledNotificationComposer: ["Components","ScheduledNotificationComposer"],
  SearchBar: ["Components","SearchBar"],
  Separator: ["Components","Separator"],
  SharedFilters: ["Components","SharedFilters"],
  ShowResourceRecord: ["Components","ShowResourceRecord"],
  Sidebar: ["Components","Sidebar"],
  SidebarCollapseButton: ["Components","SidebarCollapseButton"],
  SidebarContent: ["Components","SidebarContent"],
  SidebarFooter: ["Components","SidebarFooter"],
  SidebarHeader: ["Components","SidebarHeader"],
  SidebarInset: ["Components","SidebarInset"],
  SidebarMenu: ["Components","SidebarMenu"],
  SidebarMenuButton: ["Components","SidebarMenuButton"],
  SidebarMenuItem: ["Components","SidebarMenuItem"],
  SidebarProvider: ["Components","SidebarProvider"],
  SidebarTrigger: ["Components","SidebarTrigger"],
  SimpleTable: ["Components","SimpleTable"],
  Skeleton: ["Components","Skeleton"],
  Slideover: ["Components","Slideover"],
  SlotPicker: ["Components","SlotPicker"],
  Spinner: ["Components","Spinner"],
  StatCard: ["Components","StatCard"],
  Step: ["Components","Step"],
  Stepper: ["Components","Stepper"],
  SubscriptionBillingPreview: ["Components","SubscriptionBillingPreview"],
  SubscriptionChangePreview: ["Components","SubscriptionChangePreview"],
  SupportChatButton: ["Components","SupportChatButton"],
  Tabs: ["Components","Tabs"],
  ThemeToggle: ["Components","ThemeToggle"],
  Timer: ["Components","Timer"],
  Tooltip: ["Components","Tooltip"],
  TwoFactorBackupCodeList: ["Components","TwoFactorBackupCodeList"],
  TwoFactorBackupCodes: ["Components","TwoFactorBackupCodes"],
  TwoFactorChallenge: ["Components","TwoFactorChallenge"],
  TwoFactorSendCodeButton: ["Components","TwoFactorSendCodeButton"],
  TwoFactorSetup: ["Components","TwoFactorSetup"],
  TwoFactorSmsConsent: ["Components","TwoFactorSmsConsent"],
  UpdateResourceRecordForm: ["Components","UpdateResourceRecordForm"],
  UserMenu: ["Components","UserMenu"],
  Video: ["Components","Video"],
  WorkflowForm: ["Components","WorkflowForm"],
  WorkspaceFieldsForm: ["Components","WorkspaceFieldsForm"],
  api: ["api"],
  auth: ["auth"],
  getInput: ["helpers","getInput"],
  getRouteBinding: ["helpers","getRouteBinding"],
  getRouteParam: ["helpers","getRouteParam"],
  getRouteParams: ["helpers","getRouteParams"],
  identity: ["identity"],
  navigationMenu: ["navigationMenu"],
  navigationMenuIds: ["navigationMenuIds"],
  page: ["page"],
  permissions: ["permissions"],
  resource: ["resource"],
  resourceId: ["resourceId"],
  resourceIds: ["resourceIds"],
  resourceOrNull: ["resourceOrNull"],
  router: ["router"],
  useAccountingEntities: ["hooks","useAccountingEntities"],
  useAnalytics: ["hooks","useAnalytics"],
  useApi: ["hooks","useApi"],
  useAvailability: ["hooks","useAvailability"],
  useAvailableSlots: ["hooks","useAvailableSlots"],
  useBulkNotificationRun: ["hooks","useBulkNotificationRun"],
  useCalendarConnections: ["hooks","useCalendarConnections"],
  useCalendarEvents: ["hooks","useCalendarEvents"],
  useCalendarSelection: ["hooks","useCalendarSelection"],
  useCalendarView: ["hooks","useCalendarView"],
  useCancelScheduledNotification: ["hooks","useCancelScheduledNotification"],
  useCreateRecord: ["hooks","useCreateRecord"],
  useCreateResourceRecordForm: ["hooks","useCreateResourceRecordForm"],
  useDataTable: ["hooks","useDataTable"],
  useDeleteResourceRecord: ["hooks","useDeleteResourceRecord"],
  useEmailMessages: ["hooks","useEmailMessages"],
  useForm: ["useForm"],
  useHoldScheduledNotification: ["hooks","useHoldScheduledNotification"],
  useInfiniteRecords: ["hooks","useInfiniteRecords"],
  useInput: ["helpers","useInput"],
  useLocalStorage: ["hooks","useLocalStorage"],
  useNewCalendarEvent: ["hooks","useNewCalendarEvent"],
  useNotificationConsent: ["hooks","useNotificationConsent"],
  useNotificationHistory: ["hooks","useNotificationHistory"],
  useNotificationHistoryDetail: ["hooks","useNotificationHistoryDetail"],
  useNotificationTemplates: ["hooks","useNotificationTemplates"],
  useNotificationTypes: ["hooks","useNotificationTypes"],
  usePackageReleaseNotes: ["hooks","usePackageReleaseNotes"],
  usePayerBalances: ["hooks","usePayerBalances"],
  usePaymentRefundPreview: ["hooks","usePaymentRefundPreview"],
  usePoll: ["hooks","usePoll"],
  usePreviewScheduledNotification: ["hooks","usePreviewScheduledNotification"],
  useQueryParams: ["hooks","useQueryParams"],
  useRecord: ["hooks","useRecord"],
  useRecordScheduleTimelines: ["hooks","useRecordScheduleTimelines"],
  useRecords: ["hooks","useRecords"],
  useResourceDataTable: ["hooks","useResourceDataTable"],
  useRestoreResourceRecord: ["hooks","useRestoreResourceRecord"],
  useResumeScheduledNotification: ["hooks","useResumeScheduledNotification"],
  useScheduleConflicts: ["hooks","useScheduleConflicts"],
  useScheduleNotification: ["hooks","useScheduleNotification"],
  useScheduledNotification: ["hooks","useScheduledNotification"],
  useSendBulkNotifications: ["hooks","useSendBulkNotifications"],
  useSendEmail: ["hooks","useSendEmail"],
  useSendNotification: ["hooks","useSendNotification"],
  useSendResolvedNotification: ["hooks","useSendResolvedNotification"],
  useSendScheduledNotificationNow: ["hooks","useSendScheduledNotificationNow"],
  useSharedFilters: ["hooks","useSharedFilters"],
  useSidebar: ["hooks","useSidebar"],
  useStepper: ["hooks","useStepper"],
  useSubscriptionChangePreview: ["hooks","useSubscriptionChangePreview"],
  useSubscriptionPreview: ["hooks","useSubscriptionPreview"],
  useTheme: ["hooks","useTheme"],
  useTwoFactorBackupCodes: ["hooks","useTwoFactorBackupCodes"],
  useTwoFactorChallenge: ["hooks","useTwoFactorChallenge"],
  useTwoFactorSetup: ["hooks","useTwoFactorSetup"],
  useUpcomingNotifications: ["hooks","useUpcomingNotifications"],
  useUpdateRecord: ["hooks","useUpdateRecord"],
  useUpdateResourceRecordForm: ["hooks","useUpdateResourceRecordForm"],
  useUpdateScheduledNotification: ["hooks","useUpdateScheduledNotification"],
  useWorkflowAction: ["hooks","useWorkflowAction"],
  useWorkflowForm: ["hooks","useWorkflowForm"],
  useWorkspaceFieldsForm: ["hooks","useWorkspaceFieldsForm"],
  useWorkspaceValues: ["hooks","useWorkspaceValues"],
  utils: ["utils"],
  workspace: ["workspace"],
});

// The types of the `Sdk` namespace, which the package exports by the same names.
export const PAGE_SDK_TYPES: Readonly<Record<string, { parameters: string; arguments: string }>> = {
  AccountingEntities: {"parameters":"","arguments":""},
  AccountingEntity: {"parameters":"","arguments":""},
  AddCalendarLinkInput: {"parameters":"","arguments":""},
  AnalyticsDistributionParams: {"parameters":"","arguments":""},
  AnalyticsGranularity: {"parameters":"","arguments":""},
  AnalyticsHandle: {"parameters":"<TResult>","arguments":"<TResult>"},
  AnalyticsKpiParams: {"parameters":"<TMetrics extends readonly import(\"diagonal:sdk-internal\").AnalyticsMetric[] = import(\"diagonal:sdk-internal\").AnalyticsMetric[]>","arguments":"<TMetrics>"},
  AnalyticsKpiResult: {"parameters":"<TMetrics extends readonly import(\"diagonal:sdk-internal\").AnalyticsMetric[] = import(\"diagonal:sdk-internal\").AnalyticsMetric[]>","arguments":"<TMetrics>"},
  AnalyticsLeaderboardParams: {"parameters":"","arguments":""},
  AnalyticsMetric: {"parameters":"","arguments":""},
  AnalyticsResource: {"parameters":"<TKind extends keyof import(\"diagonal:sdk-internal\").SdkResourceAnalytics>","arguments":"<TKind>"},
  AnalyticsRow: {"parameters":"","arguments":""},
  AnalyticsTimeSeriesMetric: {"parameters":"","arguments":""},
  AnalyticsTimeSeriesParams: {"parameters":"","arguments":""},
  AnalyticsValue: {"parameters":"","arguments":""},
  Api: {"parameters":"","arguments":""},
  ApiError: {"parameters":"","arguments":""},
  ApiErrorBody: {"parameters":"","arguments":""},
  ApiFetcher: {"parameters":"<TData>","arguments":"<TData>"},
  ApiHandle: {"parameters":"<TData>","arguments":"<TData>"},
  ApiQueryKey: {"parameters":"","arguments":""},
  Auth: {"parameters":"","arguments":""},
  AuthConfig: {"parameters":"","arguments":""},
  AuthLoginInput: {"parameters":"","arguments":""},
  AuthMagicLinkInput: {"parameters":"","arguments":""},
  AuthPasswordResetInput: {"parameters":"","arguments":""},
  AuthResource: {"parameters":"","arguments":""},
  AvailabilityHandle: {"parameters":"","arguments":""},
  AvailabilityOptions: {"parameters":"","arguments":""},
  AvailabilityPiece: {"parameters":"","arguments":""},
  AvailableSlot: {"parameters":"","arguments":""},
  AvailableSlotsHandle: {"parameters":"","arguments":""},
  AvailableSlotsOptions: {"parameters":"","arguments":""},
  BadgeVariant: {"parameters":"","arguments":""},
  BookingCreateResult: {"parameters":"","arguments":""},
  BrandLogoOptions: {"parameters":"","arguments":""},
  BulkNotificationRun: {"parameters":"","arguments":""},
  BulkNotificationVariable: {"parameters":"","arguments":""},
  CalendarAccessRole: {"parameters":"","arguments":""},
  CalendarChoice: {"parameters":"","arguments":""},
  CalendarChoices: {"parameters":"","arguments":""},
  CalendarConnectionsHandle: {"parameters":"","arguments":""},
  CalendarEventsChoice: {"parameters":"","arguments":""},
  CalendarLink: {"parameters":"","arguments":""},
  CalendarLinkFlags: {"parameters":"","arguments":""},
  CalendarLinkState: {"parameters":"","arguments":""},
  CalendarLinks: {"parameters":"","arguments":""},
  CalendarLogin: {"parameters":"","arguments":""},
  CalendarResult: {"parameters":"","arguments":""},
  CalendarSignInResult: {"parameters":"","arguments":""},
  CalendarStaff: {"parameters":"","arguments":""},
  CalendarUnavailableReason: {"parameters":"","arguments":""},
  CancelScheduledNotificationHandle: {"parameters":"","arguments":""},
  CancelledNotificationResult: {"parameters":"","arguments":""},
  CatalogRecord: {"parameters":"<TResourceId extends string, TRelations extends readonly import(\"diagonal:sdk-internal\").SdkCatalogRelationPath<TResourceId>[] = readonly []>","arguments":"<TResourceId, TRelations>"},
  CatalogRelationPath: {"parameters":"<TResourceId extends string>","arguments":"<TResourceId>"},
  ClassValue: {"parameters":"","arguments":""},
  ClipboardCopyOptions: {"parameters":"","arguments":""},
  ConfettiOptions: {"parameters":"","arguments":""},
  ContentValue: {"parameters":"","arguments":""},
  Contract: {"parameters":"","arguments":""},
  CreateRecordHandle: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  DateAddUnit: {"parameters":"","arguments":""},
  DateBoundaryUnit: {"parameters":"","arguments":""},
  DisplayFormatOptions: {"parameters":"","arguments":""},
  DisplayUtils: {"parameters":"","arguments":""},
  Dnd: {"parameters":"","arguments":""},
  DndCanDrag: {"parameters":"<TItem, TLocation extends import(\"diagonal:sdk-internal\").SdkDndLocation = import(\"diagonal:sdk-internal\").SdkDndLocation>","arguments":"<TItem, TLocation>"},
  DndCanDrop: {"parameters":"<TItem, TLocation extends import(\"diagonal:sdk-internal\").SdkDndLocation = import(\"diagonal:sdk-internal\").SdkDndLocation>","arguments":"<TItem, TLocation>"},
  DndCustomPersistence: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndGroupMoveChange: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndGroupMoveResult: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndGroupedLocation: {"parameters":"","arguments":""},
  DndIdentifier: {"parameters":"","arguments":""},
  DndItemIdentifier: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndLocation: {"parameters":"","arguments":""},
  DndMoveContext: {"parameters":"<TItem, TLocation extends import(\"diagonal:sdk-internal\").SdkDndLocation = import(\"diagonal:sdk-internal\").SdkDndLocation>","arguments":"<TItem, TLocation>"},
  DndReorder: {"parameters":"","arguments":""},
  DndReorderChange: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndReorderResult: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndResourcePersistence: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndSortableGroupRenderState: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndSortableGroupsCommonProps: {"parameters":"<TItem, TGroup>","arguments":"<TItem, TGroup>"},
  DndSortableGroupsComponent: {"parameters":"","arguments":""},
  DndSortableGroupsCustomPersistence: {"parameters":"<TItem, TGroup>","arguments":"<TItem, TGroup>"},
  DndSortableGroupsProps: {"parameters":"<TItem, TGroup>","arguments":"<TItem, TGroup>"},
  DndSortableGroupsResourcePersistence: {"parameters":"<TItem, TGroup>","arguments":"<TItem, TGroup>"},
  DndSortableGroupsResourceProps: {"parameters":"<TResource extends import(\"diagonal:sdk-internal\").SdkResourceType & Pick<import(\"diagonal:sdk-internal\").SdkResource, 'fields' | 'updateMany'>, TItem extends import(\"diagonal:sdk-internal\").SdkDndResourceItem<NoInfer<TResource>>, TGroup>","arguments":"<TResource, TItem, TGroup>"},
  DndSortableItem: {"parameters":"","arguments":""},
  DndSortableListCommonProps: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndSortableListComponent: {"parameters":"","arguments":""},
  DndSortableListProps: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndSortableListResourceProps: {"parameters":"<TResource extends import(\"diagonal:sdk-internal\").SdkResourceType & Pick<import(\"diagonal:sdk-internal\").SdkResource, 'fields' | 'updateMany'>, TItem extends import(\"diagonal:sdk-internal\").SdkDndResourceItem<NoInfer<TResource>> = import(\"diagonal:sdk-internal\").SdkDndResourceItem<TResource>>","arguments":"<TResource, TItem>"},
  DndSortableOptions: {"parameters":"<TItem>","arguments":"<TItem>"},
  DndSortableRenderState: {"parameters":"","arguments":""},
  EmailAddress: {"parameters":"","arguments":""},
  EmailAttempt: {"parameters":"","arguments":""},
  EmailAttemptAttachment: {"parameters":"","arguments":""},
  EmailAttemptEvent: {"parameters":"","arguments":""},
  EmailAttemptRecipients: {"parameters":"","arguments":""},
  EmailAttemptStatus: {"parameters":"","arguments":""},
  EmailMessage: {"parameters":"","arguments":""},
  EmailMessages: {"parameters":"","arguments":""},
  EmailMessagesFilters: {"parameters":"","arguments":""},
  EmailMessagesOptions: {"parameters":"","arguments":""},
  EmailMessagesRecord: {"parameters":"","arguments":""},
  EmailRecipient: {"parameters":"","arguments":""},
  EmailRecipientRole: {"parameters":"","arguments":""},
  EventScheduleValue: {"parameters":"","arguments":""},
  FieldSelector: {"parameters":"<TKey extends string = string>","arguments":"<TKey>"},
  FieldValue: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord, TSelector extends import(\"diagonal:sdk-internal\").SdkFieldSelector>","arguments":"<TRecord, TSelector>"},
  FormField: {"parameters":"","arguments":""},
  FormFieldProps: {"parameters":"","arguments":""},
  FormWrapperProps: {"parameters":"","arguments":""},
  GoogleCalendarLoginStatus: {"parameters":"","arguments":""},
  HeldNotificationResult: {"parameters":"","arguments":""},
  Helpers: {"parameters":"","arguments":""},
  HoldScheduledNotificationHandle: {"parameters":"","arguments":""},
  Hooks: {"parameters":"","arguments":""},
  Identity: {"parameters":"","arguments":""},
  InfiniteRecordsHandle: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  ListItemField: {"parameters":"","arguments":""},
  LocalStorageArray: {"parameters":"","arguments":""},
  LocalStorageObject: {"parameters":"","arguments":""},
  LocalStoragePrimitive: {"parameters":"","arguments":""},
  LocalStorageResult: {"parameters":"<TValue>","arguments":"<TValue>"},
  LocalStorageSetter: {"parameters":"<TValue>","arguments":"<TValue>"},
  LocalStorageValue: {"parameters":"","arguments":""},
  LocationFormatOptions: {"parameters":"","arguments":""},
  LocationValue: {"parameters":"","arguments":""},
  Money: {"parameters":"","arguments":""},
  MoneyFormatOptions: {"parameters":"","arguments":""},
  MoneyInput: {"parameters":"","arguments":""},
  NavigateOptions: {"parameters":"","arguments":""},
  NavigationMenu: {"parameters":"","arguments":""},
  NavigationMenuCatalog: {"parameters":"","arguments":""},
  NotificationChannel: {"parameters":"","arguments":""},
  NotificationChannelAvailability: {"parameters":"","arguments":""},
  NotificationChannelUnavailableReason: {"parameters":"","arguments":""},
  NotificationChannels: {"parameters":"","arguments":""},
  NotificationConsent: {"parameters":"","arguments":""},
  NotificationConsentChannels: {"parameters":"","arguments":""},
  NotificationConsentHandle: {"parameters":"","arguments":""},
  NotificationDeliveryChannel: {"parameters":"","arguments":""},
  NotificationHistory: {"parameters":"","arguments":""},
  NotificationHistoryDetail: {"parameters":"","arguments":""},
  NotificationHistoryItem: {"parameters":"","arguments":""},
  NotificationHistoryKind: {"parameters":"","arguments":""},
  NotificationHistoryOptions: {"parameters":"","arguments":""},
  NotificationHistoryRecord: {"parameters":"","arguments":""},
  NotificationHistoryStatus: {"parameters":"","arguments":""},
  NotificationListOptions: {"parameters":"","arguments":""},
  NotificationRecipient: {"parameters":"","arguments":""},
  NotificationSourceKind: {"parameters":"","arguments":""},
  NotificationTemplateList: {"parameters":"","arguments":""},
  NotificationTemplateSummary: {"parameters":"","arguments":""},
  NotificationTypeList: {"parameters":"","arguments":""},
  NotificationTypeListOptions: {"parameters":"","arguments":""},
  NotificationTypeSummary: {"parameters":"","arguments":""},
  NotificationVariableSummary: {"parameters":"","arguments":""},
  NotifyToastOptions: {"parameters":"","arguments":""},
  NotifyVariant: {"parameters":"","arguments":""},
  NumberFormatOptions: {"parameters":"","arguments":""},
  PackageReleaseHistory: {"parameters":"","arguments":""},
  PackageReleaseNotes: {"parameters":"","arguments":""},
  PackageReleaseNotesOptions: {"parameters":"","arguments":""},
  PackageReleaseNotesProps: {"parameters":"","arguments":""},
  PageAliasCatalog: {"parameters":"","arguments":""},
  PageHandle: {"parameters":"","arguments":""},
  PageRef: {"parameters":"<K extends string = string, P extends import(\"diagonal:sdk-internal\").PageRefParams | undefined = import(\"diagonal:sdk-internal\").PageRefParams | undefined>","arguments":"<K, P>"},
  PageRefParams: {"parameters":"","arguments":""},
  PageReference: {"parameters":"","arguments":""},
  PageRouteSettings: {"parameters":"","arguments":""},
  PayerBalances: {"parameters":"","arguments":""},
  PayerBalancesOptions: {"parameters":"","arguments":""},
  PayerEntityBalance: {"parameters":"","arguments":""},
  PaymentRefundPreview: {"parameters":"","arguments":""},
  PaymentRefundPreviewHandle: {"parameters":"","arguments":""},
  PaymentRefundPreviewOptions: {"parameters":"","arguments":""},
  Permissions: {"parameters":"","arguments":""},
  PhoneFormatOptions: {"parameters":"","arguments":""},
  PointValue: {"parameters":"","arguments":""},
  PollControls: {"parameters":"","arguments":""},
  PollInterval: {"parameters":"<TData>","arguments":"<TData>"},
  PreviewNotificationInput: {"parameters":"","arguments":""},
  PreviewNotificationResponse: {"parameters":"","arguments":""},
  RecordAvailability: {"parameters":"","arguments":""},
  RecordHandle: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  RecordInput: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  RecordMutationState: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  RecordOf: {"parameters":"<TKey extends keyof import(\"diagonal:sdk-internal\").ResourceRecordCatalog>","arguments":"<TKey>"},
  RecordScheduleTimeline: {"parameters":"","arguments":""},
  RecordScheduleTimelineOffset: {"parameters":"","arguments":""},
  RecordScheduleTimelinesHandle: {"parameters":"","arguments":""},
  RecordsHandle: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  RecurrenceDefinition: {"parameters":"","arguments":""},
  RecurrenceValue: {"parameters":"","arguments":""},
  ReferenceRecord: {"parameters":"<TReference extends import(\"diagonal:sdk-internal\").ResourceTypeReference, TRelations extends readonly import(\"diagonal:sdk-internal\").SdkReferenceRelationPath<TReference>[] = readonly []>","arguments":"<TReference, TRelations>"},
  ReferenceRelationPath: {"parameters":"<TReference extends import(\"diagonal:sdk-internal\").ResourceTypeReference>","arguments":"<TReference>"},
  RegularHoursDay: {"parameters":"","arguments":""},
  RegularHoursValue: {"parameters":"","arguments":""},
  ResolvedNotification: {"parameters":"","arguments":""},
  ResolvedNotificationEmail: {"parameters":"","arguments":""},
  Resource: {"parameters":"<TFields extends Record<string, import(\"diagonal:sdk-internal\").SdkResourceField> = Record<string, import(\"diagonal:sdk-internal\").SdkResourceField>, TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord, TRelations extends import(\"diagonal:sdk-internal\").ResourceRelationCatalog = import(\"diagonal:sdk-internal\").ResourceRelationCatalog, TWorkflowInputs extends import(\"diagonal:sdk-internal\").SdkResourceWorkflowInputs = import(\"diagonal:sdk-internal\").SdkResourceWorkflowInputs>","arguments":"<TFields, TRecord, TRelations, TWorkflowInputs>"},
  ResourceAnalytics: {"parameters":"","arguments":""},
  ResourceBulkUpdateRecord: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  ResourceCapabilityFieldMappings: {"parameters":"","arguments":""},
  ResourceCollectionResult: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  ResourceCountOptions: {"parameters":"","arguments":""},
  ResourceDeletePayload: {"parameters":"","arguments":""},
  ResourceField: {"parameters":"","arguments":""},
  ResourceFieldSettings: {"parameters":"","arguments":""},
  ResourceFieldSettingsUi: {"parameters":"","arguments":""},
  ResourceFieldUpdatePayload: {"parameters":"","arguments":""},
  ResourceForm: {"parameters":"","arguments":""},
  ResourceFormWorkflowInputs: {"parameters":"<TResource extends Pick<import(\"diagonal:sdk-internal\").SdkResource, 'workflow_inputs'>, TEvents extends import(\"diagonal:sdk-internal\").SdkWorkflowEvent>","arguments":"<TResource, TEvents>"},
  ResourceHandle: {"parameters":"","arguments":""},
  ResourceListParams: {"parameters":"<TRelations extends readonly string[] = readonly string[]>","arguments":"<TRelations>"},
  ResourceOperation: {"parameters":"","arguments":""},
  ResourceOperationRecord: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  ResourceOperations: {"parameters":"<TResource extends import(\"diagonal:sdk-internal\").SdkResourceType = import(\"diagonal:sdk-internal\").SdkResourceType>","arguments":"<TResource>"},
  ResourcePagination: {"parameters":"","arguments":""},
  ResourceQueryHandle: {"parameters":"<TUrl extends keyof import(\"diagonal:sdk-internal\").ResourceUrls = 'show' | 'search'>","arguments":"<TUrl>"},
  ResourceQueryReference: {"parameters":"<TUrl extends keyof import(\"diagonal:sdk-internal\").ResourceUrls = 'show' | 'search'>","arguments":"<TUrl>"},
  ResourceRecord: {"parameters":"","arguments":""},
  ResourceRecordCatalog: {"parameters":"","arguments":""},
  ResourceRecordFormActionsProps: {"parameters":"","arguments":""},
  ResourceRecordFormFieldsProps: {"parameters":"","arguments":""},
  ResourceRecordFormStep: {"parameters":"<RenderState>","arguments":"<RenderState>"},
  ResourceRecordFrom: {"parameters":"<TResource extends import(\"diagonal:sdk-internal\").SdkResourceType | null | undefined, TRelations extends readonly import(\"diagonal:sdk-internal\").SdkResourceRelationPath<NonNullable<TResource>>[] = readonly []>","arguments":"<TResource, TRelations>"},
  ResourceRecordPayload: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  ResourceRecordResult: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  ResourceRecordsResult: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  ResourceReference: {"parameters":"","arguments":""},
  ResourceRelationCatalog: {"parameters":"","arguments":""},
  ResourceRelationPath: {"parameters":"<TResource extends import(\"diagonal:sdk-internal\").SdkResourceType>","arguments":"<TResource>"},
  ResourceRelationsFrom: {"parameters":"<TResource extends import(\"diagonal:sdk-internal\").SdkResourceType>","arguments":"<TResource>"},
  ResourceSearchAllOptions: {"parameters":"<TRelations extends readonly string[] = readonly string[]>","arguments":"<TRelations>"},
  ResourceSearchBody: {"parameters":"<TRelations extends readonly string[] = readonly string[]>","arguments":"<TRelations>"},
  ResourceSortDescriptor: {"parameters":"","arguments":""},
  ResourceSortDirection: {"parameters":"","arguments":""},
  ResourceSortFieldDescriptor: {"parameters":"","arguments":""},
  ResourceSortInput: {"parameters":"","arguments":""},
  ResourceType: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord, TRelations extends import(\"diagonal:sdk-internal\").ResourceRelationCatalog = import(\"diagonal:sdk-internal\").ResourceRelationCatalog>","arguments":"<TRecord, TRelations>"},
  ResourceUrls: {"parameters":"","arguments":""},
  ResourceWorkflowInputs: {"parameters":"","arguments":""},
  ResumeScheduledNotificationHandle: {"parameters":"","arguments":""},
  Router: {"parameters":"","arguments":""},
  RouterVisitOptions: {"parameters":"","arguments":""},
  SchedulableRecordRef: {"parameters":"","arguments":""},
  ScheduleConflict: {"parameters":"","arguments":""},
  ScheduleConflictsHandle: {"parameters":"","arguments":""},
  ScheduleConflictsOptions: {"parameters":"","arguments":""},
  ScheduleNotificationHandle: {"parameters":"","arguments":""},
  ScheduleNotificationInput: {"parameters":"","arguments":""},
  ScheduledNotificationContent: {"parameters":"","arguments":""},
  ScheduledNotificationDetail: {"parameters":"","arguments":""},
  ScheduledNotificationEdits: {"parameters":"","arguments":""},
  ScheduledNotificationPreview: {"parameters":"","arguments":""},
  ScheduledNotificationResult: {"parameters":"","arguments":""},
  SelectedResourceRecord: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord, TRelationCatalog extends import(\"diagonal:sdk-internal\").ResourceRelationCatalog, TRelations extends readonly Extract<keyof TRelationCatalog, string>[] = readonly []>","arguments":"<TRecord, TRelationCatalog, TRelations>"},
  SendBulkNotificationsHandle: {"parameters":"","arguments":""},
  SendBulkNotificationsInput: {"parameters":"","arguments":""},
  SendEmailHandle: {"parameters":"","arguments":""},
  SendEmailInput: {"parameters":"","arguments":""},
  SendEmailResponse: {"parameters":"","arguments":""},
  SendNotificationHandle: {"parameters":"","arguments":""},
  SendNotificationInput: {"parameters":"","arguments":""},
  SendNotificationResponse: {"parameters":"","arguments":""},
  SendResolvedNotificationHandle: {"parameters":"","arguments":""},
  SendResolvedNotificationInput: {"parameters":"","arguments":""},
  SendScheduledNotificationNowHandle: {"parameters":"","arguments":""},
  SeriesChangeResult: {"parameters":"","arguments":""},
  SeriesOccurrenceMeta: {"parameters":"","arguments":""},
  SlotSearchGroup: {"parameters":"","arguments":""},
  SmsMessage: {"parameters":"","arguments":""},
  SmsMessageStatus: {"parameters":"","arguments":""},
  SubscriptionChangePreview: {"parameters":"","arguments":""},
  SubscriptionChangePreviewHandle: {"parameters":"","arguments":""},
  SubscriptionChangePreviewOptions: {"parameters":"","arguments":""},
  SubscriptionPreview: {"parameters":"","arguments":""},
  SubscriptionPreviewHandle: {"parameters":"","arguments":""},
  SubscriptionPreviewOptions: {"parameters":"","arguments":""},
  TextGenerateOptions: {"parameters":"","arguments":""},
  TimeAddUnit: {"parameters":"","arguments":""},
  TimeBoundaryUnit: {"parameters":"","arguments":""},
  TiptapParseInput: {"parameters":"","arguments":""},
  TwoFactorBackupCodesHandle: {"parameters":"","arguments":""},
  TwoFactorBackupCodesState: {"parameters":"","arguments":""},
  TwoFactorChallengeHandle: {"parameters":"","arguments":""},
  TwoFactorChallengeState: {"parameters":"","arguments":""},
  TwoFactorFlow: {"parameters":"","arguments":""},
  TwoFactorMode: {"parameters":"","arguments":""},
  TwoFactorPending: {"parameters":"","arguments":""},
  TwoFactorRequestState: {"parameters":"","arguments":""},
  TwoFactorSetupHandle: {"parameters":"","arguments":""},
  TwoFactorSetupState: {"parameters":"","arguments":""},
  TwoFactorSetupStep: {"parameters":"","arguments":""},
  UpcomingNotification: {"parameters":"","arguments":""},
  UpcomingNotifications: {"parameters":"","arguments":""},
  UpcomingNotificationsOptions: {"parameters":"","arguments":""},
  UpdateRecordHandle: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  UpdateScheduledNotificationHandle: {"parameters":"","arguments":""},
  UpdateScheduledNotificationInput: {"parameters":"","arguments":""},
  UseAnalyticsOptions: {"parameters":"","arguments":""},
  UseApiOptions: {"parameters":"<TData = any>","arguments":"<TData>"},
  UseCalendarConnectionsOptions: {"parameters":"","arguments":""},
  UseCreateRecordOptions: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  UseCreateResourceRecordFormResult: {"parameters":"","arguments":""},
  UseForm: {"parameters":"","arguments":""},
  UseInfiniteRecordsOptions: {"parameters":"<TRelations extends readonly string[] = readonly string[]>","arguments":"<TRelations>"},
  UseNotificationConsentOptions: {"parameters":"","arguments":""},
  UsePollOptions: {"parameters":"","arguments":""},
  UseRecordOptions: {"parameters":"<TRelations extends readonly string[] = readonly string[], TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRelations, TRecord>"},
  UseRecordScheduleTimelinesOptions: {"parameters":"","arguments":""},
  UseRecordsOptions: {"parameters":"<TRelations extends readonly string[] = readonly string[], TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRelations, TRecord>"},
  UseSendEmailOptions: {"parameters":"","arguments":""},
  UseSendNotificationOptions: {"parameters":"","arguments":""},
  UseTwoFactorOptions: {"parameters":"","arguments":""},
  UseUpdateRecordOptions: {"parameters":"<TRecord extends import(\"diagonal:sdk-internal\").ResourceRecord = import(\"diagonal:sdk-internal\").ResourceRecord>","arguments":"<TRecord>"},
  UseUpdateResourceRecordFormResult: {"parameters":"","arguments":""},
  UseWorkflowActionResult: {"parameters":"","arguments":""},
  UseWorkflowFormResult: {"parameters":"","arguments":""},
  UseWorkspaceFieldsFormOptions: {"parameters":"","arguments":""},
  UseWorkspaceFieldsFormResult: {"parameters":"","arguments":""},
  Utils: {"parameters":"","arguments":""},
  WorkflowEvent: {"parameters":"","arguments":""},
  WorkflowForm: {"parameters":"","arguments":""},
  WorkflowInput: {"parameters":"","arguments":""},
  WorkflowInputProps: {"parameters":"","arguments":""},
  WorkflowInputSettings: {"parameters":"","arguments":""},
  WorkflowInputsProps: {"parameters":"","arguments":""},
  WorkflowOutput: {"parameters":"","arguments":""},
  WorkflowPendingResponse: {"parameters":"","arguments":""},
  WorkflowReference: {"parameters":"","arguments":""},
  WorkflowResponse: {"parameters":"","arguments":""},
  WorkflowRouteSettings: {"parameters":"","arguments":""},
  WorkflowTarget: {"parameters":"","arguments":""},
  Workspace: {"parameters":"","arguments":""},
  WorkspaceField: {"parameters":"","arguments":""},
  WorkspaceFields: {"parameters":"","arguments":""},
  WorkspaceFieldsForm: {"parameters":"","arguments":""},
  WorkspaceRecord: {"parameters":"","arguments":""},
  WorkspaceValues: {"parameters":"","arguments":""},
};
